// "This browser has logged in before" marker (Veronika, 2026-10-01: returning members must
// not be asked for the marketing opt-in again on every sign-in). Set whenever a session is
// seen, deliberately NOT cleared on logout; the login island reads it to skip the consent
// box. A bare flag, no identity. It lives in two places: localStorage (written here) and a
// cookie of the same name stamped by /api/auth/stamp, because Safari clears script-written
// storage after a week away. A member on a brand-new browser has neither and is asked once
// more there (ticking again is a server-side no-op).
export const RETURNING_MEMBER_KEY = 'ea_returning_member'

export function markReturningMember() {
  try {
    window.localStorage.setItem(RETURNING_MEMBER_KEY, '1')
  } catch {
    // storage blocked: they are simply asked again next time
  }
}

export function isReturningMember(): boolean {
  try {
    if (window.localStorage.getItem(RETURNING_MEMBER_KEY) === '1') return true
  } catch {
    // storage blocked: fall through to the cookie
  }
  return document.cookie.split('; ').includes(`${RETURNING_MEMBER_KEY}=1`)
}
